import * as Common from '@/tenant/common';

export class Account extends Common.MasterBase{
  constructor(){
    super('Account');
    this.state = Common.MasterBaseStatus.NotPosted;
    this.workflowStateId = Common.MasterBaseStatus.NotPosted;
  }
  public code: string = '';
  public name: string = '';
  public debitCredit: Common.DebitCreditFlags = null;
  public accountCategory: AccountCategoryTypes = Common.AccountCategoryTypes.Default;
  public mappingCode: string = null;

  public copy():any {
    const temp = super.copy() as Account;
    temp.code = null;    
    temp.state = Common.MasterBaseStatus.NotPosted;
    temp.workflowStateId = Common.MasterBaseStatus.NotPosted;
    return temp;
  }
}

export enum AccountCategoryTypes
{
  Default = 0,
  PurchaseCharge = 1,
  SalesCharge = 2,

  // Debt = 1,
  // CashDeposits = 2,
  // SalesAmount = 3,
  // PurchaseAmount = 4,
  // InventoryAdjustment = 5,
  // SalesChargeAmount = 6,
  // PurchaseChargeAmount = 7,
  // Other = 8,
}

export class AccountQuery extends Common.LoadQuery {
  constructor(){
    super('AccountQuery',Account);
    this.sort = 'code';
  }

  public code: string = '';
  public name: string = '';
  public accountCategory: Common.AccountCategoryTypes = null;
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.MasterBaseStatus = null;
  public holder: string = '';
  public auditNo: string ='';
}

export class AccountMasterQuery extends Common.LoadQuery {
  constructor(){
    super('AccountMasterQuery', Account);
  }
  public accountCategory: AccountCategoryTypes = null;
}

export class SalesChargeAccountMasterQuery extends Common.LoadQuery {
  constructor(){
    super('AccountMasterQuery', Account);
  }
  public accountCategory: AccountCategoryTypes = AccountCategoryTypes.SalesCharge;
}

export class PurchaseChargeAccountMasterQuery extends Common.LoadQuery {
  constructor(){
    super('AccountMasterQuery', Account);
  }
  public accountCategory: AccountCategoryTypes = AccountCategoryTypes.PurchaseCharge;
}